import { convertMediaTrack } from './utils';
import { errorPlayerContainerNotCreated } from './errors';
export const playerSelectedAudioTrack = (container) => {
    if (!container) {
        throw errorPlayerContainerNotCreated;
    }
    const player = container.getAny();
    return {
        selectedAudioTrack: {
            track: player.selectedAudioTrack ? convertMediaTrack(player.selectedAudioTrack) : undefined,
        },
    };
};
